import { render, staticRenderFns } from "./UnPublishIcon.vue?vue&type=template&id=ebef4a74&scoped=true"
import script from "./UnPublishIcon.vue?vue&type=script&lang=js"
export * from "./UnPublishIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebef4a74",
  null
  
)

export default component.exports